import React from 'react';
import TimeEntriesAdmin from '../components/TimeEntriesAdmin/TimeEntriesAdmin';

const TimeEntriesAdminPage = () => {
  return (
    <div>
      <TimeEntriesAdmin />
    </div>
  );
};

export default TimeEntriesAdminPage;